import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ReviewWitnessInterviewComponent } from '../../../../components/review-content/review-witness-interview/review-witness-interview.component';

@Component({
  selector: 'witness-interview-submission',
  standalone: true,
  imports: [
    CommonModule,
    ReviewWitnessInterviewComponent
  ],
  templateUrl: './witness-interview-submission.component.html',
  styleUrl: './witness-interview-submission.component.css'
})
export class WitnessInterviewSubmissionComponent implements OnInit {

  @Input() witnessInterviewData: any = {};
  @Output() onSaveSection6 = new EventEmitter<any>();

  currentCaseId: string | null = null;

  ngOnInit(): void {
    if (this.witnessInterviewData) {
      this.currentCaseId = this.witnessInterviewData.case_id;
    }
  }

  submitWitnessInterview(): void {
    this.onSaveSection6.emit({});
  }
}
